export enum PolicyFields {
  BANK = "BANK",
  CLIENT = "CLIENT",
  DECLARATION = "DECLARATION",
  DISASTER = "DISASTER",
  FOROPTTARIF = "FOROPTTARIF",
  GENERAL = "GENERAL",
  OPTIONALSERVICE = "OPTIONALSERVICE",
}
